/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeleteUserPayload } from '../models/DeleteUserPayload';
import type { IntroUpdateRequest } from '../models/IntroUpdateRequest';
import type { ProfileUpdateRequest } from '../models/ProfileUpdateRequest';
import type { UserProfile } from '../models/UserProfile';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserService {
    /**
     * Get Profile
     * @returns UserProfile Successful Response
     * @throws ApiError
     */
    public static getProfileApiUserProfileGet(): CancelablePromise<UserProfile> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/profile',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
    }
    /**
     * Update Profile
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static updateProfileApiUserProfilePatch(
        requestBody: ProfileUpdateRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/user/profile',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Intro
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static updateIntroApiUserIntroPost(
        requestBody: IntroUpdateRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/intro',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete User
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteUserApiUserDeleteDelete(
        requestBody: DeleteUserPayload,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/user/delete',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Log Activity
     * @returns any Successful Response
     * @throws ApiError
     */
    public static logActivityApiUserActivityPost(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/activity',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
